import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

export const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.colors.accent,
  fontSize: 13,
  textDecoration: 'underline',
}));

export const Container = styled.div(({ theme }) => ({
  gap: 10,
  display: 'flex',
  overflow: 'hidden',
  svg: {
    flexShrink: 0,
    marginTop: 1, // Svg is a little bit misaligned
    transform: 'rotate(-125deg)',
    path: {
      fill: theme.colors.inactive,
    },
  },
}));

export default StyledLink;
